import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('api', 'representante-logado');

const representanteLogadoActions = {
  clientes: { method: 'GET', url: `${basePath}/clientes?indAtivo=true&colunaOrdenacao=nom_cliente` },
};


export default resource => resource(`${basePath}`, {}, representanteLogadoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/representante-logado.js